import { render, staticRenderFns } from "./updateRelay.vue?vue&type=template&id=51de6d69&"
import script from "./updateRelay.vue?vue&type=script&lang=js&"
export * from "./updateRelay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports